import React from 'react';
import PropTypes from 'prop-types';
import 'components/styles/side-chart.css';
import CloseIcon from 'assets/images/close';
import useSmallScreenSize from 'hooks/useSmallScreenSize';

const SideChart = ({ data }) => {
  const isSmallScreen = useSmallScreenSize();

  return (
    <div
      className={`offcanvas ${isSmallScreen ? 'offcanvas-bottom' : 'offcanvas-end'}`}
      tabIndex="-1"
      id={`${isSmallScreen ? 'offcanvasBottom' : 'offcanvasWithBackdrop'}`}
      aria-labelledby="offcanvasWithBackdropLabel">
      <div
        className="offcanvas-header"
        id={`${isSmallScreen ? 'bottomSheetHeader' : 'sideChartHeader'}`}>
        <h5 className="offcanvas-title center" id="offcanvasWithBackdropLabel">
          {data.heading}
        </h5>
        <button
          type="button"
          className="btn-close text-reset close"
          data-bs-dismiss="offcanvas"
          aria-label="Close">
          <CloseIcon width="24" height="24" color="black" />
        </button>
      </div>
      <div className={`${isSmallScreen ? 'bottomSheetBody' : 'offcanvas-body sideChartBody'}`}>
        <div>
          <pre>{data.content}</pre>
        </div>
      </div>
      <div className="gotIt">
        <button data-bs-dismiss="offcanvas">Got it!</button>
      </div>
    </div>
  );
};

SideChart.propTypes = {
  data: PropTypes.object
};

export default SideChart;
